export default __webpack_public_path__ + "img/QOJNoLDb.d1bc6f63.svg";